import { ChevronDown } from "lucide-react";
import { memo, useState, type ReactNode } from "react";

export interface FilterSectionProps {
  /** Section heading, e.g. "Suppliers". */
  title: string;
  /** The checkbox rows. */
  children: ReactNode;
}

/**
 * Collapsible filter section for the cart's filter rail.
 *
 * Deliberately mirrors the search page's own `FilterSection` (title row with a
 * rotating chevron, `space-y-2` rows beneath) so both rails read as one system.
 * The search version is coupled to InstantSearch's `useRefinementList`, which
 * the cart has no equivalent of, so the shape is shared rather than the code.
 */
export const FilterSection = memo(function FilterSection({
  title,
  children
}: FilterSectionProps) {
  const [isExpanded, setIsExpanded] = useState(true);

  return (
    <div className="mb-6">
      <button
        type="button"
        onClick={() => setIsExpanded(!isExpanded)}
        aria-expanded={isExpanded}
        className="mb-2 flex w-full items-center justify-between text-sm font-medium"
      >
        {title}
        <ChevronDown
          className={`h-4 w-4 transition-transform ${isExpanded ? "rotate-180" : ""}`}
          aria-hidden="true"
        />
      </button>
      {isExpanded && <div className="space-y-2">{children}</div>}
    </div>
  );
});
